import { Suspense, useEffect, useState } from "react";
import { lazyRetry } from "@/lib/lazyRetry";
import { Routes, Route } from "react-router-dom";
import axios from "axios";
import { effectiveHost, isSimulatedHost, shopBackendBase } from "@/lib/customDomain";

const ShopGateway = lazyRetry(() => import("@/pages/ShopGateway"));
const OrderTrackingPage = lazyRetry(() => import("@/pages/OrderTrackingPage"));

const Spinner = () => (
  <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#faf7f2" }} data-testid="domain-loading">
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-neutral-800" />
  </div>
);

// Storefront-only router for custom store domains (juliacenterlb.com).
// Resolves the hostname to a tenant, redirects www → canonical, and never
// exposes the POS/admin app on the store domain.
export default function CustomDomainShop() {
  const [state, setState] = useState({ status: "loading", slug: "" });

  useEffect(() => {
    const host = effectiveHost();
    axios.get(`${shopBackendBase()}/api/public/domains/resolve`, { params: { host } })
      .then((r) => {
        const d = r.data || {};
        if (!d.found) { setState({ status: "notfound" }); return; }
        if (d.canonical_host && d.canonical_host !== host && !isSimulatedHost()) {
          window.location.replace(`https://${d.canonical_host}${window.location.pathname}${window.location.search}`);
          return;
        }
        setState({ status: "ok", slug: d.tenant_slug });
      })
      .catch(() => setState({ status: "notfound" }));
  }, []);

  if (state.status === "loading") return <Spinner />;
  if (state.status === "notfound") {
    return (
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8, background: "#faf7f2", fontFamily: "Inter, sans-serif" }} data-testid="domain-not-found">
        <h1 style={{ fontSize: 22, fontWeight: 700, color: "#1c1917" }}>Store not found</h1>
        <p style={{ fontSize: 14, color: "#78716c" }}>This domain is not connected to any store.</p>
      </div>
    );
  }
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route path="/track/:orderNumber" element={<OrderTrackingPage domainSlug={state.slug} />} />
        <Route path="/*" element={<ShopGateway domainSlug={state.slug} routeMode />} />
      </Routes>
    </Suspense>
  );
}
